export const frontmatter = {
    "draft": false,
    "title": "System configuration",
    "description": "General configuration of the OnnIA system.",
    "sidebar_label": "System configuration",
    "sidebar_group": "reference",
    "sidebar_order": 5
}

export const toc = []